import React from "react"
import CharacterCountTextarea from "./DynamicTextareaCharacterCount"
import StandardDynamicTextarea from "./DynamicTextareaStandard"
import {
    characterLimitPropType,
    dynamicTextareaPropTypes,
} from "./dynamicTextarea.propTypes"

const hasCharacterLimit = (characterLimit) => Number.isInteger(characterLimit) && characterLimit >= 0

const DynamicTextarea = ({ characterLimit, ...props }) => {
    return hasCharacterLimit(characterLimit)
        ? <CharacterCountTextarea {...props} characterLimit={characterLimit} />
        : <StandardDynamicTextarea {...props} />
}

DynamicTextarea.propTypes = {
    ...dynamicTextareaPropTypes,
    characterLimit: characterLimitPropType,
}

DynamicTextarea.defaultProps = {
    minRows: 1,
    disabled: false,
    readOnly: false,
    error: false,
    helperText: "",
    characterLimit: undefined,
    inputProps: undefined,
    onFocus: undefined,
    onBlur: undefined,
}

export default DynamicTextarea
